
import styles from './index.module.scss'

interface IProps {
  __html: string
}

export default function CKEContent({
  __html
}: IProps) {

  return (
    <div
      className={styles.Content}
      dangerouslySetInnerHTML={{ __html }}
    >
    </div>
  )
}
